import * as React from 'react';
export const posthogSvg = React.forwardRef(function posthogSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement(
      'g',
      {
        clipPath: 'url(#bi_posthog__a)',
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M9.664 15.947a.52.52 0 0 1-.93 0l-.459-.916a.52.52 0 0 1 0-.466l.458-.916a.52.52 0 0 1 .93 0l.459.916a.52.52 0 0 1 0 .466l-.458.916Zm0 5.199a.52.52 0 0 1-.93 0l-.459-.917a.52.52 0 0 1 0-.465l.458-.917a.52.52 0 0 1 .93 0l.459.917a.52.52 0 0 1 0 .465l-.458.917Z',
        fill: '#1D4AFF',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M4 19.172a.52.52 0 0 1 .888-.367l2.383 2.383a.52.52 0 0 1-.368.888H4.52a.52.52 0 0 1-.52-.52v-2.384Zm0-2.51c0 .138.055.27.152.368l4.894 4.893a.52.52 0 0 0 .368.153h2.688a.52.52 0 0 0 .367-.888l-7.581-7.582a.52.52 0 0 0-.888.368v2.688Zm0-5.198c0 .137.055.27.152.367l10.093 10.092a.52.52 0 0 0 .367.153H17.3a.52.52 0 0 0 .368-.888L4.888 8.408A.52.52 0 0 0 4 8.775v2.688Zm5.198 0c0 .137.055.27.153.367l9.357 9.357a.52.52 0 0 0 .887-.368v-2.688a.52.52 0 0 0-.152-.367l-9.357-9.357a.52.52 0 0 0-.888.367v2.688Zm6.087-3.056a.52.52 0 0 0-.888.367v2.688c0 .138.055.27.152.368l4.159 4.159a.52.52 0 0 0 .887-.368v-2.688a.52.52 0 0 0-.152-.368l-4.158-4.158Z',
        fill: '#F9BD2B',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm26.113 19.236-4.895-4.895a.52.52 0 0 0-.887.368v6.847c0 .287.232.52.52.52h7.582a.52.52 0 0 0 .52-.52v-.624c0-.287-.234-.516-.52-.553a4.015 4.015 0 0 1-2.32-1.143Zm-3.287 1.176a.832.832 0 1 1 0-1.664.832.832 0 0 1 0 1.664Z',
        fill: '#000',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M4 21.556c0 .287.233.52.52.52h2.383a.52.52 0 0 0 .368-.888l-2.383-2.383a.52.52 0 0 0-.888.367v2.384Zm5.198-8.838-4.31-4.31A.52.52 0 0 0 4 8.775v2.688c0 .138.055.27.152.368l5.046 5.046V12.72Zm-4.31.888a.52.52 0 0 0-.888.368v2.688c0 .138.055.27.152.368l5.046 5.046v-4.159l-4.31-4.31Z',
        fill: '#1D4AFF',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M14.397 12.934a.52.52 0 0 0-.153-.368l-4.158-4.158a.52.52 0 0 0-.888.367v2.688c0 .138.055.27.153.368l5.046 5.046v-3.943Zm-5.199 9.142h2.904a.52.52 0 0 0 .367-.888L9.2 17.917v4.159Zm0-9.357v3.943c0 .138.055.27.153.368l5.046 5.046v-3.944a.52.52 0 0 0-.153-.367l-5.046-5.046Z',
        fill: '#F54E00',
      }),
    ),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'clipPath',
        {
          id: 'bi_posthog__a',
        },
        /*#__PURE__*/ React.createElement('path', {
          fill: '#fff',
          transform: 'translate(4 7)',
          d: 'M0 0h26v15.6H0z',
        }),
      ),
    ),
  );
});
posthogSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var posthog = {
  category: 'brand',
  colorable: false,
  name: 'posthog',
  svg: posthogSvg,
};
